import { useApiQuery } from 'hooks/useApiQuery'

export const useGetFeatureAccess = ({
  currentStateId = 0,
  enabled = true,
}: {
  currentStateId: number
  enabled?: boolean
}) =>
  useApiQuery({
    path: '/me/featureaccess',
    method: 'get',
    queryKey: ['/me/featureaccess'],
    queryArgs: {},
    enabled,
    requestHeaders: currentStateId
      ? { 'Current-State-Id': currentStateId.toString() }
      : undefined,
  })
